import { createSelector } from 'reselect';

const getBulkData = ({ bulkUploadV2 }) => {
	return bulkUploadV2.bulkFiles;
};

const getUploadingStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 && bulkUploadV2.isUploading;
};

const getProcessingStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 && bulkUploadV2.isProcessing;
};

const getUploadAllowedStatus = ({ bulkUploadV2 }) => {
	return bulkUploadV2 &&
		bulkUploadV2.uploadStatus &&
		bulkUploadV2.uploadStatus.data &&
		bulkUploadV2.uploadStatus.data.uploadAllowed;
};

export const getModel = createSelector([
	getBulkData,
	getUploadAllowedStatus,
	getUploadingStatus,
	getProcessingStatus,
], (
	bulkFiles,
	isUploadAllowed,
	isUploading,
	isProcessing,
) => {
	return {
		bulkFiles,
		isUploadAllowed,
		isUploading,
		isProcessing,
	};
});
